export default __webpack_public_path__ + "static/media/Exorcist.ca626c6b.mp3";